

import { useState, useEffect } from "react";
import { Lock, Mail } from "lucide-react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

export function SecurityPanel() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user?.email) {
      setEmail(user.email);
    }
  }, []);

  const handlePasswordReset = async () => {
    if (!email) {
      setMessage("No email found. Please log in again.");
      return;
    }
    setLoading(true);
    setMessage(null);
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setMessage(`✅ Password reset email sent to ${email}. Check your inbox.`);
    } catch (err: any) {
      console.error('Password reset error', err);
      setMessage(err.message || 'Failed to send password reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mb-6 lg:mb-0 rounded-3xl border border-white/10 bg-zinc-900/70 p-5 text-white">
      <div className="mb-4 flex items-center gap-2 text-sm text-white/70">
        <Lock className="h-4 w-4" /> Account security
      </div>
      <label className="text-xs uppercase text-white/60">Email</label>
      <div className="mt-1 flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-3">
        <Mail className="h-4 w-4 text-white/40" />
        <input
          value={email}
          readOnly
          className="w-full bg-transparent py-2 text-sm outline-none text-white/70"
        />
      </div>
      <button
        onClick={handlePasswordReset}
        disabled={loading}
        className="mt-4 w-full rounded-2xl bg-white/15 px-4 py-3 text-center text-sm font-semibold transition hover:bg-white/20 disabled:opacity-50"
      >
        {loading ? "Sending..." : "Reset password"}
      </button>
      {message && <p className="mt-2 text-xs text-white/60">{message}</p>}
    </section>
  );
}
